var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24H48C48 10.7452 37.2548 0 24 0Z",
    fill: "#E62048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.33855C14.6271 7.55581 11.9617 10.2311 11.9617 13.5 11.9617 16.7689 14.6271 19.4442 18 19.6615 17.316 19.881 16.5834 20 15.8218 20 12.054 20 9 17.0899 9 13.5 9 9.9102 12.054 7 15.8218 7 16.5834 7 17.316 7.11906 18 7.33855zM20.6183 11.7135L20.7867 10.7318 20.0734 10.0365 21.0591 9.89324 21.4999 9 21.9408 9.89324 22.9265 10.0365 22.2132 10.7318 22.3816 11.7135 21.4999 11.25 20.6183 11.7135z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 13.25L17.6183 13.7135 17.7867 12.7318 17.0734 12.0365 18.0591 11.8932 18.4999 11 18.9408 11.8932 19.9265 12.0365 19.2132 12.7318 19.3816 13.7135 18.4999 13.25zM20.3023 16.2934L20.4706 17.2752 19.589 16.8116 18.7073 17.2752 18.8757 16.2934 18.1624 15.5981 19.1481 15.4549 19.589 14.5616 20.0298 15.4549 21.0155 15.5981 20.3023 16.2934zM24.4999 13.25L23.6183 13.7135 23.7867 12.7318 23.0734 12.0365 24.0591 11.8932 24.4999 11 24.9408 11.8932 25.9265 12.0365 25.2132 12.7318 25.3816 13.7135 24.4999 13.25zM22.5591 17.2926L22.7275 16.3109 22.0142 15.6156 22.9999 15.4724 23.4408 14.5791 23.8816 15.4724 24.8674 15.6156 24.1541 16.3109 24.3225 17.2926 23.4408 16.8291 22.5591 17.2926z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 11.0213 36.9787 0.5 24 0.5C11.0213 0.5 0.5 11.0213 0.5 24C0.5 36.9787 11.0213 47.5 24 47.5C36.9787 47.5 47.5 36.9787 47.5 24Z",
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgSg;